export var OECTagType;
(function (OECTagType) {
  OECTagType["OECMODEL"] = "OECMODEL";
  OECTagType["OECUSER"] = "OECUSER";
  OECTagType["SENTIMENT"] = "SENTIMENT";
  OECTagType["USER"] = "USER";
})(OECTagType || (OECTagType = {}));
export var OECDiscardKeywordGenerationModal;
(function (OECDiscardKeywordGenerationModal) {
  OECDiscardKeywordGenerationModal["HIDE_KEYWORDS_MODAL"] = "HIDE_KEYWORDS_MODAL";
  OECDiscardKeywordGenerationModal["SHOW_KEYWORDS_MODAL_BACK"] = "SHOW_KEYWORDS_MODAL_BACK";
  OECDiscardKeywordGenerationModal["SHOW_KEYWORDS_MODAL_CLOSED"] = "SHOW_KEYWORDS_MODAL_CLOSED";
})(OECDiscardKeywordGenerationModal || (OECDiscardKeywordGenerationModal = {}));
export var OECDiscardKeywordsModal;
(function (OECDiscardKeywordsModal) {
  OECDiscardKeywordsModal["HIDE_KEYWORDS_MODAL"] = "HIDE_KEYWORDS_MODAL";
  OECDiscardKeywordsModal["SHOW_KEYWORDS_MODAL_BACK"] = "SHOW_KEYWORDS_MODAL_BACK";
  OECDiscardKeywordsModal["SHOW_KEYWORDS_MODAL_CLOSED"] = "SHOW_KEYWORDS_MODAL_CLOSED";
})(OECDiscardKeywordsModal || (OECDiscardKeywordsModal = {}));
export var OECSentiment;
(function (OECSentiment) {
  OECSentiment["SM_NEGATIVE"] = "SM_NEGATIVE";
  OECSentiment["SM_NEUTRAL"] = "SM_NEUTRAL";
  OECSentiment["SM_NOT_ENABLED"] = "SM_NOT_ENABLED";
  OECSentiment["SM_POSITIVE"] = "SM_POSITIVE";
  OECSentiment["SM_UNDETECTED"] = "SM_UNDETECTED";
})(OECSentiment || (OECSentiment = {}));
export var OECJobState;
(function (OECJobState) {
  OECJobState["QUEUED"] = "QUEUED";
  OECJobState["FAILED"] = "FAILED";
  OECJobState["IN_PROGRESS"] = "IN_PROGRESS";
  OECJobState["SUCCESS"] = "SUCCESS";
})(OECJobState || (OECJobState = {}));
export var SORT_BY;
(function (SORT_BY) {
  SORT_BY["DATE"] = "DATE";
  SORT_BY["ALPHABETICALLY"] = "ALPHABETICAL";
})(SORT_BY || (SORT_BY = {}));
export var FILTER_BY_TAGGED_STATUS;
(function (FILTER_BY_TAGGED_STATUS) {
  FILTER_BY_TAGGED_STATUS["ALL"] = "ALL";
  FILTER_BY_TAGGED_STATUS["TAGGED"] = "TAGGED";
  FILTER_BY_TAGGED_STATUS["UNTAGGED"] = "UNTAGGED";
})(FILTER_BY_TAGGED_STATUS || (FILTER_BY_TAGGED_STATUS = {}));
export var OECCreatedSource;
(function (OECCreatedSource) {
  OECCreatedSource["THEMES"] = "themes";
  OECCreatedSource["AUTO_TAGGING"] = "autotagging";
})(OECCreatedSource || (OECCreatedSource = {}));
export var TRAINING_STEP;
(function (TRAINING_STEP) {
  TRAINING_STEP["KEYWORD_GENERATION"] = "keyword_generation";
  TRAINING_STEP["KEYWORD_FETCHING"] = "keyword_fetching";
  TRAINING_STEP["KEYWORDS_LOADED"] = "keywords_loaded";
  TRAINING_STEP["KEYWORDS_VIEWING"] = "keywords_view";
  TRAINING_STEP["TRAINING_IN_PROGRESS"] = "training_in_progress";
  TRAINING_STEP["TRAINING_FINISHED"] = "training_finished";
  TRAINING_STEP["TRAINING_ERROR"] = "training_error";
})(TRAINING_STEP || (TRAINING_STEP = {}));
export var OECTrainingStatus;
(function (OECTrainingStatus) {
  OECTrainingStatus["NOT_TRAINED"] = "NOT_TRAINED";
  OECTrainingStatus["REQUIRES_RETRAINING"] = "REQUIRES_RETRAINING";
  OECTrainingStatus["TRAINING_COMPLETE"] = "TRAINING_COMPLETE";
})(OECTrainingStatus || (OECTrainingStatus = {}));
export var OECRetrainStepProgress;
(function (OECRetrainStepProgress) {
  OECRetrainStepProgress["HIDE_STEP"] = "HIDE_STEP";
  OECRetrainStepProgress["STEP_IN_PROGRESS"] = "STEP_IN_PROGRESS";
  OECRetrainStepProgress["STEP_COMPLETE"] = "STEP_COMPLETE";
})(OECRetrainStepProgress || (OECRetrainStepProgress = {}));